import { render, staticRenderFns } from "./BulkDownloadForm.vue?vue&type=template&id=39966310"
import script from "./BulkDownloadForm.vue?vue&type=script&lang=js"
export * from "./BulkDownloadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports